var map = {
	"./main_demoinnovation.scss": [
		"51ff",
		"chunk-74832d4d"
	],
	"./main_demoinsurance.scss": [
		"5249",
		"chunk-7482e087"
	],
	"./main_global.scss": [
		"42de",
		"chunk-7475828a"
	],
	"./main_iama.scss": [
		"58b0",
		"chunk-74864658"
	],
	"./main_previnet.scss": [
		"d997",
		"chunk-771c7256"
	],
	"./main_shdev.scss": [
		"74ec",
		"chunk-74a0b54e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "856d";
module.exports = webpackAsyncContext;